// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"qn-z","badgeLink":"rn-z","category":"sn-z"};